import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.href;
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo Silencio TTPM',
        content_ids: ['protocolo-silencio-ttpm'],
        content_type: 'product',
        value: 11.99,
        currency: 'USD'
      });
    }
    setTimeout(() => {
      window.location.href = href;
    }, 300);
  };
  return <section id="comprar" className="py-20 md:py-32 px-5 md:px-8 relative overflow-hidden" data-id="element-223">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#F6C65B] rounded-full blur-[150px] opacity-10 -z-10 pointer-events-none" data-id="element-224"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-[#0B1224] to-[#070B16] p-8 md:p-12 rounded-3xl border border-[#F6C65B]/40 shadow-[0_0_50px_rgba(246,198,91,0.15)]" data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-227">
            Empieza esta noche con el Protocolo Silencio TTPM™
          </h2>

          <p className="text-gray-300 text-lg md:text-xl mb-8" data-id="element-228">
            Llévatelo todo —protocolo + 4 bonos— por un único pago simbólico.
          </p>

          <div className="my-10 space-y-4" data-id="element-229">
            <div className="flex justify-center items-center gap-3" data-id="element-230">
              <span className="text-gray-500 line-through text-2xl md:text-3xl font-semibold" data-id="element-231">
                Valor total: $247 USD
              </span>
            </div>
            <div className="flex justify-center" data-id="element-232">
              <span className="bg-green-500/20 text-green-400 border border-green-500/30 font-bold text-sm md:text-base px-4 py-1.5 rounded-full" data-id="element-233">
                🔥 Hoy ahorras $235.01 USD
              </span>
            </div>
            <div className="flex justify-center items-start gap-2 pt-2" data-id="element-234">
              <span className="text-3xl font-bold text-[#F6C65B] mt-2" data-id="element-235">$</span>
              <span className="text-7xl font-bold text-[#F6C65B] tracking-tighter" data-id="element-236">
                11.99
              </span>
              <span className="text-xl font-bold text-[#F6C65B] mt-8" data-id="element-237">USD</span>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-238">
              Pago único · Sin suscripción
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-239">
            <a href="https://pay.hotmart.com/M105215372D?checkoutMode=10" onClick={handleCheckoutClick} className="bg-[#F6C65B] hover:bg-[#FFD680] text-[#070B16] font-bold text-xl md:text-2xl px-8 py-5 rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(246,198,91,0.5)] transform hover:scale-105 active:scale-95 w-full max-w-md flex flex-col items-center justify-center gap-1" data-id="element-240">
              <span data-id="element-241">Sí, quiero empezar esta noche</span>
            </a>
            <p className="text-gray-400 text-sm mt-2" data-id="element-242">
              🔒 Pago seguro · Acceso inmediato · Garantía de satisfacción
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}